import { useEffect, useRef } from "react";
import { Menu } from "lucide-react";
import { ToolLinks } from "./ToolLinks";
import "../styles/tool-navigation.css";

type Props = { current?: "aesthetic" | "discord" | "roblox" | "tiktok" };

export function ToolNavigation({ current }: Props) {
  const menu = useRef<HTMLDetailsElement>(null);
  useEffect(() => {
    const closeOutside = (event: PointerEvent) => {
      if (event.target instanceof Node && !menu.current?.contains(event.target)) menu.current?.removeAttribute("open");
    };
    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape" && menu.current?.open) {
        menu.current.removeAttribute("open");
        menu.current.querySelector("summary")?.focus();
      }
    };
    document.addEventListener("pointerdown", closeOutside);
    document.addEventListener("keydown", closeOnEscape);
    return () => {
      document.removeEventListener("pointerdown", closeOutside);
      document.removeEventListener("keydown", closeOnEscape);
    };
  }, []);
  return <>
    <nav className="tool-desktop-navigation" aria-label="Main navigation"><ToolLinks current={current} /></nav>
    <details ref={menu} className="mobile-navigation tool-mobile-navigation">
      <summary aria-label="Menu"><Menu size={21} aria-hidden="true" /></summary>
      <nav aria-label="Mobile navigation" onClick={event => {
        if ((event.target as HTMLElement).closest("a")) menu.current?.removeAttribute("open");
      }}><ToolLinks current={current} /></nav>
    </details>
  </>;
}
